export function filtrarAcoesAutorizadas(acoes, verificarPermissao) {
  return (acoes || []).filter((acao) => {
    if (!acao.permissao) return true;

    try {
      return !!verificarPermissao(acao.permissao);
    } catch {
      return true;
    }
  });
}
